import { Iri } from 'lib/utils/iri';
import { privateApi } from 'services';
import {
    CreateJobCampaign,
    JobCampaign,
    JobCampaignAdvertisementsPickedItems,
    UpdatedJobCampaignsAdGroups,
    UpdateJobCampaign,
    UpdateJobCampaignsAdGroups,
} from './types';

const fetchJobCampaign = async (jobCampaignId: string): Promise<JobCampaign> =>
    privateApi.get<JobCampaign>(`job-campaigns/${jobCampaignId}`);

const pickItemsForAdvertisements = async (
    businessAccountId: string,
    contentTags: Iri[],
): Promise<JobCampaignAdvertisementsPickedItems> =>
    privateApi.post<JobCampaignAdvertisementsPickedItems>(
        `business-accounts/${businessAccountId}/jobs/pick-items-for-advertisements`,
        {
            contentTags,
        },
    );

const createCampaign = async (jobCampaign: CreateJobCampaign): Promise<JobCampaign> =>
    privateApi.post<JobCampaign>('job-campaigns', jobCampaign);

const createCampaignFromVacancy = async (vacancyId: string, jobCampaign: CreateJobCampaign): Promise<JobCampaign> =>
    privateApi.post<JobCampaign>(`job-vacancies/${vacancyId}/create-job-campaign-from-vacancy`, jobCampaign);

const updateCampaign = async (jobCampaignId: string, jobCampaign: UpdateJobCampaign): Promise<JobCampaign> =>
    privateApi.put<JobCampaign>(`job-campaigns/${jobCampaignId}`, jobCampaign);

const updateAdGroups = async (
    jobCampaignId: string,
    updateJobCampaignsAdGroups: UpdateJobCampaignsAdGroups,
): Promise<UpdatedJobCampaignsAdGroups> =>
    privateApi.put<UpdatedJobCampaignsAdGroups>(`job-campaigns/${jobCampaignId}/ad-groups`, updateJobCampaignsAdGroups);

const activateJobCampaign = async (jobCampaignId: string): Promise<JobCampaign> =>
    privateApi.post<JobCampaign>(`job-campaigns/${jobCampaignId}/activate`, {});

const deactivateJobCampaign = async (jobCampaignId: string): Promise<JobCampaign> =>
    privateApi.post<JobCampaign>(`job-campaigns/${jobCampaignId}/deactivate`, {});

const linkCampaignMode = async (jobCampaignId: string): Promise<JobCampaign> =>
    privateApi.post<JobCampaign>(`job-campaigns/${jobCampaignId}/link-campaign-mode`, {});

const unlinkCampaignMode = async (jobCampaignId: string): Promise<JobCampaign> =>
    privateApi.post<JobCampaign>(`job-campaigns/${jobCampaignId}/unlink-campaign-mode`, {});

const linkVacancy = async (jobCampaignId: string, vacancyId: string): Promise<void> =>
    privateApi.post<void>(`job-campaigns/${jobCampaignId}/link-vacancy/${vacancyId}`, {});

export const JobCampaignGateway = {
    fetchJobCampaign,
    pickItemsForAdvertisements,
    createCampaign,
    createCampaignFromVacancy,
    updateCampaign,
    updateAdGroups,
    activateJobCampaign,
    deactivateJobCampaign,
    linkCampaignMode,
    unlinkCampaignMode,
    linkVacancy,
};
